import React from 'react';

export default function LoadingDropdownItem() {
  return (
    <div className="business-dropdown-item loading">
      <div className="loading-spinner" />
    </div>
  );
}
